<template>
  <div class="notice-new">
    <p>お知らせ作成</p>
		<div class="notice-table">
			<b-form @submit.prevent="noticeCreateProc">
				<b-form-group
					id="input-group-1"
					label="件名"
					label-for="input-1">
					<b-form-input
						id="input-1"
						v-model="form.title"
						type="text"
						required
						placeholder="">
					</b-form-input>
				</b-form-group>
				<b-form-group
					id="textarea-rows"
					label="内容"
					label-for="textarea-rows">
					<b-form-textarea
						id="textarea-rows"
						placeholder=""
						v-model="form.content"
						rows="5"
					></b-form-textarea>
				</b-form-group>
				<p class="notice-create-btn">
					<b-button type="submit">新規</b-button>
				</p>
			</b-form>
		</div>
  </div>
</template>
<script>
export default {
  methods: {
  },
  data () {
    return {
			form: {
				title: '',
				content: ''
			}
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
		noticeCreateProc() {
			this.$modal.show('dialog', {
        title: this.form.title,
        text: this.form.content,
        buttons: [
          {
            title: 'はい',
            handler: () => {
							apiClient.createNotice(this.form)
								.then(response => {
									this.$modal.hide('dialog')
									this.$router.go(-1)
								})
            }
          },
          {
            title: 'キャンセル'
          }
        ]
      })
		}
  },
}
</script>
